// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__fYxjq","Image__caption":"Image_Image__caption__a5ubK","fadeInKeyframe":"Image_fadeInKeyframe__1TVVu"};